import { H6, Image } from "../../../../../../AbstractElements";
import { SuccessfullyCompleted } from "../../../../../../Constants/Constants";
import { dynamicImage } from "../../../../../../Utils";

const CompletedForm = () => {
  return (
    <div className="form-completed">
      <Image src={dynamicImage(`gif/successful.gif`)} alt="successful" />
      <H6>{SuccessfullyCompleted}</H6>
    </div>
  );
};
export default CompletedForm;
